import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../BaseExcelExportDialog.styles';
import { OtherOptionsProps } from './OtherOptions.props';

export const OtherOptions = ({
  otherOptions,
  setOtherOptions,
  showCondition,
  options,
}: OtherOptionsProps) => {
  if (!showCondition) {
    return null;
  }

  const handleOptionChange = (optionKey: string) => {
    setOtherOptions({
      ...otherOptions,
      [optionKey]: !otherOptions[optionKey],
    });
  };

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        {options.map(option => (
          <FormControlLabel
            key={option.key}
            control={
              <Checkbox
                checked={otherOptions[option.key]}
                onChange={() => handleOptionChange(option.key)}
                disabled={option.disabled}
              />
            }
            label={option.label}
          />
        ))}
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
